import { useNavigate } from 'react-router-dom';
import T from '../theme';

const F = "'Plus Jakarta Sans', sans-serif";

export default function Footer() {
 const navigate = useNavigate();

 const links = [
 { label: 'Services', to: '/services' },
 { label: 'Process', to: '/process' },
 { label: 'Work', to: '/work' },
 { label: 'About', to: '/about' },
 { label: 'Contact', to: '/contact' },
 ];

 return (
 <footer style={{ background: T.navy, padding: '52px 5%' }}>
 <div style={{
 maxWidth: 1280, margin: '0 auto',
 display: 'flex', justifyContent: 'space-between',
 alignItems: 'center', flexWrap: 'wrap', gap: 28,
 }}>
 <div>
 <button
 onClick={() => navigate('/')}
 style={{ background: 'none', border: 'none', cursor: 'pointer', display: 'flex', alignItems: 'baseline', gap: 0, marginBottom: 8 }}
 >
 <span style={{ fontFamily: F, fontWeight: 800, fontSize: '1.25rem', color: T.white }}>UX</span>
 <span style={{ fontFamily: F, fontWeight: 400, fontSize: '1.25rem', color: T.aqua }}>tudio</span>
 </button>
 {/* <p style={{ fontSize: '0.9rem', color: 'rgba(255,255,255,0.45)' }}>
 Making products easier to use, one team at a time.
 </p> */}
 </div>

 <div style={{ display: 'flex', gap: 32, flexWrap: 'wrap' }}>
 {links.map(l => (
 <button
 key={l.to}
 onClick={() => navigate(l.to)}
 style={{
 background: 'none', border: 'none', cursor: 'pointer',
 fontFamily: F, fontSize: '0.9rem', color: 'rgba(255,255,255,0.5)',
 transition: 'color 0.2s',
 }}
 onMouseEnter={e => (e.target.style.color = T.aqua)}
 onMouseLeave={e => (e.target.style.color = 'rgba(255,255,255,0.5)')}
 >
 {l.label}
 </button>
 ))}
 </div>

 <p style={{ fontSize: '0.82rem', color: 'rgba(255,255,255,0.3)' }}>© 2025 UXtudio</p>
 </div>
 </footer>
 );
}
